module.exports = __webpack_public_path__ + "img/ye.a619a7aa.svg";